<template>
    <v-flex class="cat-img" md8 xs11>
      <v-img :src="`/img/categories/thumbs/${catImage}.jpg`"></v-img>
      <!-- <span class="cat-jobs">
        <nuxt-link
          :to="`/jobs/cat${catCode}/`"
          class="no-underline display-12"
        >{{numberOfJobs}} משרות</nuxt-link>
      </span> -->
    </v-flex>

</template>


<script>
export default {
  props: {
    catImage: {
      type: [Number, String],
      required: false,
      default: ''
    },
    catCode: {
      type: Number,
      required: false,
      default: ''
    },
    numberOfJobs: {
      type: [Number, String],
      required: false,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.cat-img {
  position: relative;
}

.cat-img .v-responsive {
  border-radius: 5px 5px 0 0;
  max-height: 115px;
  opacity: 0.5;
}

.cat-img .cat-jobs {
  font-size: 12px;
  position: absolute;
  z-index: 1;
  top: 5px;
  left: 5px;
  display: inline-flex;
  color: $primary;
  background: rgba(255, 255, 255, 0.8);
  padding: 2px 16px;
  border-radius: 13px;
}

@media only screen and (min-width: 600px) {
}
</style>
